export class ViewModelFiltraProcesso {
    idProcesso: number;
    idStatus: number;
    dtInicio: Date;
    dtFim: Date;
    idPlano: number;
    idOrder: number;
}